"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapTimelineToQuery = exports.mapSearchToQuery = void 0;
exports.mapSearchToQuery = {
    any: 'listAny',
    action: 'listAction',
    alert: 'listAlert',
    alertStatus: 'listAlertStatus',
    analyzer_template: 'listAnalyzerTemplate',
    audit: 'listAudit',
    case: 'listCase',
    caseReportTemplate: 'listCaseReportTemplate',
    caseStatus: 'listCaseStatus',
    caseTemplate: 'listCaseTemplate',
    catalog: 'listCatalog',
    comment: 'listComment',
    customEvent: 'listCustomEvent',
    customField: 'listCustomField',
    dashboard: 'listDashboard',
    function: 'listFunction',
    job: 'listJob',
    log: 'listLog',
    observable: 'listObservable',
    observableType: 'listObservableType',
    organisation: 'listOrganisation',
    pageTemplate: 'listPageTemplate',
    pattern: 'listPattern',
    procedure: 'listProcedure',
    profile: 'listProfile',
    share: 'listShare',
    tag: 'listTag',
    task: 'listTask',
    taxonomy: 'listTaxonomy',
    user: 'listUser',
};
exports.mapTimelineToQuery = {
    Case: 'getCase',
    Alert: 'getAlert',
    Task: 'getTask',
    Observable: 'getObservable',
    Function: 'getFunction',
    Procedure: 'getProcedure',
    Log: 'getLog',
    CustomEvent: 'getCustomEvent',
};
